import React, { useEffect, useRef, useState } from 'react';
import qs from 'query-string';
import { GetSettings } from './dataStore/configstore';
import { GetCustomFields, GetRequestType, GetRequestTypes } from './dataStore/atlassian-services';
import SearchField from './components/SearchField.component';
import FreeTextField from './components/FreeTextField.component';
import { useAP } from './contexts/AtlassianContext';
import Spinner from '@atlaskit/spinner';

const App = () => {
  const { context, token, location } = useAP();

  // const [token, setToken] = useState('');
  const [fieldConfigs, setFieldConfigs] = useState({ loaded: false, fieldConfigs: [] });

  // const [licenseStatus, setLicenseStatus] = useState(true);
  const [requestType, setRequestType] = useState({});
  const [issueFieldsArray, setIssueFieldsArray] = useState([]);
  const [isFetched, setIsFetched] = useState({
    isFetched: false,
    plusHeight: 0,
  });
  const componentRef = useRef(null);

  useEffect(() => {
    // const { jwt } = qs.parse(window.location.search);
    // setToken(token);

    if (token) fetchConfigs(token);
  }, [token]);

  useEffect(() => {
    if (!componentRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      let newHeight = componentRef.current.offsetHeight;
      newHeight = newHeight + isFetched.plusHeight;

      if (newHeight !== componentRef.current.dataset.lastHeight) {
        document.body.style.overflow = 'hidden';
        window.AP.resize('100%', newHeight);
        componentRef.current.dataset.lastHeight = newHeight;
      }
    });
    resizeObserver.observe(componentRef.current);
    return () => {
      resizeObserver.disconnect();
      document.body.style.overflow = '';
    };
  }, [isFetched]);

  const fetchConfigs = async (retrievedToken) => {
    if (!context?.jira) return;

    let [fetchedDataSources, fetchedFieldConfigurations] = await Promise.all([
      GetSettings(retrievedToken, 'Json_DataSources'),
      GetSettings(retrievedToken, 'Json_FieldConfigurations'),
    ]);

    const projectKey = context.jira.project.key;
    const issue = context.jira.issue;

    let url = location.split(/[?#]/)[0];
    let match = url.match(/[0-9]+(?!.*[0-9])/)?.[0];

    if (issue) {
      await window.AP.request(`/rest/servicedeskapi/request/${issue.key}`)
        .then((data) => {
          let json = JSON.parse(data.body);
          if (json) {
            match = json.requestTypeId;
          }
        })
        .catch((e) => console.log(e.err));
    }

    if (match) {
      const requestTypes = await GetRequestTypes();
      const requestType = requestTypes.find((n) => n.id === match);
      setRequestType(requestType);

      fetchedFieldConfigurations = fetchedFieldConfigurations.filter(
        (n) => !n.requestTypes?.length || n.requestTypes.includes(match.toString())
      );
    }

    if (issue?.issuetype) {
      fetchedFieldConfigurations = fetchedFieldConfigurations.filter(
        (n) => !n.issueTypes?.length || n.issueTypes.includes(issue.issuetype.id)
      );
    }

    fetchedFieldConfigurations = fetchedFieldConfigurations.filter(
      (n) => n.projects?.includes(projectKey) && n.status
    );

    if (!fetchedFieldConfigurations || fetchedFieldConfigurations.length === 0) {
      window.AP.resize('100%', '0px');
      return;
    }

    const fieldConfigs = fetchedFieldConfigurations.map((n) => ({
      fieldConfig: n,
      dataSource: fetchedDataSources.find((d) => d.id === n.dataSource),
    }));
    setFieldConfigs({ loaded: true, fieldConfigs: fieldConfigs });

    setIssueFieldsArray(await GetCustomFields(retrievedToken));
    const fetchResult = {
      isFetched: true,
      plusHeight:
        fetchedFieldConfigurations.filter(
          (n) => n.fieldType === 'select' || n.fieldType === 'asyncselect'
        ).length > 0
          ? 100
          : 0,
    };
    setIsFetched(fetchResult);
  };

  if (!fieldConfigs || !fieldConfigs.loaded)
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spinner size={'medium'} />
      </div>
    );

  return (
    <div ref={componentRef}>
      {fieldConfigs.fieldConfigs.map((item, index) => (
        <div key={index}>
          {item.fieldConfig.fieldType === 'freeText' ? (
            <FreeTextField
              fieldConfig={item.fieldConfig}
              issueFieldsArray={issueFieldsArray}
              requestType={requestType}
              copyToSummary={
                item.fieldConfig.copyToSummary &&
                fieldConfigs.fieldConfigs.filter(
                  (n) => n.fieldConfig.fieldType !== 'freeText' && n.fieldConfig.copyToSummary
                ).length === 0
              }
            />
          ) : (
            <SearchField
              issueFieldsArray={issueFieldsArray}
              fieldConfig={item.fieldConfig}
              dataSource={item.dataSource}
              requestType={requestType}
              token={token}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default App;
